
import { Component, Prop, Vue } from "vue-property-decorator";
import SquareShadowBox from "@/components/SquareShadowBox.vue";
import Benefactor from "@/models/Sobrevivencia/Benefactor";
import { getBenefactorName } from "@/utils/HelperFunctions";
import BenefactorDocument from "@/models/Sobrevivencia/BenefactorDocument";

@Component({
  components: { SquareShadowBox },
})
export default class BenefactorsRequiredDocuments extends Vue {
  @Prop({ default: [] }) benefactors: Benefactor[];
  @Prop({ default: [] }) generalDocs: BenefactorDocument[];
  public getBenefactorName = getBenefactorName;

  public fields = [
    {
      key: "descDocumento",
      label: "Documento",
    } 
     
  ];
}
